import Parse from "parse";
import { store } from "src/store/store";
import { CACHE_NAME } from "src/modules/activity-log/constants";
import debug from "src/modules/debug-logger";
import {
  signOutRequest,
  anonymousSignInSuccess
} from "src/modules/auth/duck/actions";
import * as Sentry from "@sentry/react";
import getUserSubscription from "src/modules/auth/ajax/getUserSubscription";
import clearParseSession from "src/modules/auth/clearParseSession";
import { webLinks } from "./web-links";

export function redirectToWebLogin() {
  window.open(webLinks.login, "_self");
}

export async function logInWithWebCredentials({
  synchronizer,
  xmppCredentials
}) {
  async function handleLogin(resolve) {
    try {
      const parseUser = window.localStorage.getItem("parseUser");
      const browserUser = parseUser ? JSON.parse(parseUser) : null;
      if (!browserUser) throw Error("User not found");
      debug.auth("Found user from browser app: ", browserUser);

      await clearParseSession();
      const foundParseUser = await Parse.User.become(browserUser.sessionToken);
      const user = foundParseUser.toJSON();

      user.subscription = await getUserSubscription();

      const response = await Parse.Cloud.run("linkWebDevice", {
        xmppLogin: xmppCredentials.xmppLogin
      });

      if (!response) throw Error("Server not available");

      Sentry?.configureScope((scope) => {
        scope.setUser({
          id: user?.objectId,
          email: user?.email
        });
      });

      // not actually anonymous, since we have user from localStorage
      store.dispatch(anonymousSignInSuccess({ user, xmppCredentials }));

      synchronizer.announceChange();
      await caches.delete(CACHE_NAME);
      await synchronizer.synchronize({ syncAll: true });

      resolve();
    } catch (err) {
      redirectToWebLogin();
    }
  }

  return new Promise((resolve) => handleLogin(resolve));
}

export async function signOutFromWeb(xmppLogin) {
  store.dispatch(signOutRequest());
  await Parse.Cloud.run("signOutWeb", { xmppLogin });
  await caches.delete(CACHE_NAME);
}
